import { render, staticRenderFns } from "./transformer.vue?vue&type=template&id=ad243cf2&scoped=true&"
import script from "./transformer.vue?vue&type=script&lang=js&"
export * from "./transformer.vue?vue&type=script&lang=js&"
import style0 from "./transformer.vue?vue&type=style&index=0&id=ad243cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad243cf2",
  null
  
)

export default component.exports